namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmVlastnostObecnyObjekt extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmVlastnostObecnyObjektReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmVlastnostObecnyObjektObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmVlastnostObecnyObjektObj());
            this.detailObj.createBase({
                contentName: "detailAdmVlastnostObecnyObjekt",
                contentCaption: "jres:33000414",  //RC 33000414 : Navázaná vlastnost
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmVlastnostObecnyObjekt", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmVlastnostObecnyObjektObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmVlastnostObecnyObjektReadDto> {
        private sxs_obj: string;
        private nazev: string;

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["stat_txt"]
        }

        setSxsDetail(): string {
            return "{0}#{1}#{2}#".format((this.data.typ_obj) ? this.data.typ_obj.toString() : "", (this.data.ixs) ? this.data.ixs : "", (this.data.ico) ? this.data.ico : "" );
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmVlastnostObecnyObjektSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            data.sxs = this.sxs_obj;
            (this.cnt.isl.AdmVlastnostObecnyObjekt.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            dataObj["nazev"] = this.nazev;
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmVlastnostObecnyObjekt", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmVlastnostObecnyObjekt.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("ico", Gordic.Prefabs.Select.ekosico(), { model: "model.ico=value.ico" })
            this.MakeSelectField("typ_obj", Gordic.Prefabs.Select.admGincobj(), { model: "model.typ_obj=value.typ_obj" })
            this.MakeField("nazev")
            this.MakeSelectField("ixs", Gordic.Prefabs.Select.admGinvovp(), {
                model: "model.typ_vps=value.typ_vps;model.ixs=value.ixs;model.ico=value.ico;model.typ_obj=value.typ_obj",
                dropdown: true,
                serverFilters: {
                    ico: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element),
                    typ_obj: new Gordic.Forms.Dependency("typ_obj", "typ_obj", true, false, this.cnt.element),
                    aktivita: 100
                }
            })
            this.MakeField("poradi", { validators: [new Gordic.Validators.Required({ stopping: true }), new Gordic.Validators.Range({ min: 1, max: 32767, stopping: true })] });
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });

        }
    }
}